<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <p>{{ notice }}</p>
          <div class="row">
            <div class="col-6">
              <z-input v-model="categoryExclusion" label="Decode Category Exclusion" name="category" :required="true" @keyup="isSave = true" />
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row">
            <div class="col-6">
              <z-input v-model="valueExclusion" label="Attribute Exclusion" name="item" @keyup="isSave = true" />
            </div>
            <div class="col-6 custom-value-wrapper">
              <input v-model="isValueType" class="custom-checkbox" type="checkbox" @click="isSave = true" />
              <span class="ms-2">Make this Exclude Attribute Only?</span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="row custom-footer">
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button type="button" class="btn btn-primary ms-2" :class="{ 'btn-danger': isSave }" @click="save()">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
export default {
  name: 'DialogExclusion',
  components: {
    ZDialog,
    ZMessage,
    ZInput
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-md',
      message: '',
      isSave: false
    }
  },
  emits: ['update:modelValue', 'closing', 'saved'],
  computed: {
    ...mapState(adasmatrixStore, ['loading']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = ''
      if (this.modelValue) {
        if (this.modelValue.type === 'ADD') {
          _title = 'Add Exclusion'
        } else {
          _title = 'Editing Exclusion'
        }
      }
      return _title
    },
    notice() {
      let _notice = ''
      if (this.modelValue) {
        if (this.modelValue.type === 'ADD') {
          _notice =
            "You're about to add a new ADAS exclusion. Setting the Attribute Exclusion, will only exclude that category's attribute (and not the category itself)."
        } else {
          _notice =
            "You're editing this exclusion. Setting the Attribute Exclusion, will only exclude that category's attribute (and not the category itself)."
        }
      }
      return _notice
    },
    categoryExclusion: {
      get() {
        let _category = ''
        if (this.modelValue) {
          _category = this.modelValue.item
        }
        return _category
      },
      set(value) {
        let _data = JSON.parse(JSON.stringify(this.modelValue))
        _data.item = value
        this.$emit('update:modelValue', _data)
      }
    },
    valueExclusion: {
      get() {
        let _value = ''
        if (this.modelValue) {
          _value = this.modelValue.value
        }
        return _value
      },
      set(value) {
        let _data = JSON.parse(JSON.stringify(this.modelValue))
        _data.value = value
        this.$emit('update:modelValue', _data)
      }
    },
    isValueType: {
      get() {
        let _is = false
        if (this.modelValuel) {
          _is = this.modelValue.isValueType
        }
        return _is
      },
      set(value) {
        let _data = JSON.parse(JSON.stringify(this.modelValue))
        _data.isValueType = value
        this.$emit('update:modelValue', _data)
      }
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['setData', 'saveAdasExclusion']),
    close() {
      this.$emit('closing')
    },
    async save() {
      let proceed = true
      this.message = ''
      if (this.categoryExclusion === null) {
        proceed = false
        this.message = 'Please provide a Category Exclusion.'
      }
      if (proceed && this.categoryExclusion.trim() === '') {
        proceed = false
        this.message = 'Please provide a Category Exclusion.'
      }
      if (proceed) {
        if (this.modelValue.isValueType) {
          if (this.modelValue.value === null) {
            proceed = false
          } else if (this.modelValue.value.trim() === '') {
            proceed = false
          }
        }
        if (proceed) {
          let data = {
            adasChecklistExclusion: this.modelValue.adasChecklistExclusion,
            item: this.modelValue.item,
            value: this.modelValue.value,
            isValueType: this.modelValue.isValueType
          }
          console.log('saving ADAS Exclusion', data)
          await this.saveAdasExclusion(data)
          this.isSave = false
          this.$emit('saved')
        } else {
          this.message = 'When Value Only, please provide a Value Exclusion.'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  min-height: 250px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
</style>
